import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { SenaceService } from 'src/app/services/senace.service';


@Component({
  selector: 'app-participacion-ciudadana',
  templateUrl: './participacion-ciudadana.component.html',
  styleUrls: ['./participacion-ciudadana.component.css']
})
export class ParticipacionCiudadanaComponent implements OnInit {
  // MECANISMOS DE PARTICIPACIÓN CIUDADANA
  componenteMecanismoParticipacionCiudadana = {
    titulo: 'MECANISMOS DE PARTICIPACIÓN CIUDADANA',
    cabecera: ['Etapa', 'Mecanismo', 'Fecha Inicio', 'Fecha Fin', 'Lugar', 'Grupo de interes', 'Estado'],
    filas: []
  };

  constructor(
    private localStorage: LocalStorage,
    private senaceService: SenaceService
  ) {

  }

  ngOnInit() {
    this.localStorage.getItem('detalle').subscribe(
      resp => {
        const datos = this.senaceService.getParticipacionCiudadana(resp);
        this.getComponenteMecanismoParticipacionCiudadana(datos);
      });
  }

  getComponenteMecanismoParticipacionCiudadana(resultado) {
    let data: any[] = resultado['registroActividades'];
    data.forEach(item => {
      let arr = [item.etapa || '', item.mecanismoparticipacion || '', item.fechaInicio || '', item.fechaFin || '', item.lugar || '', item.grupoInteres || '', item.estado || ''];
      this.componenteMecanismoParticipacionCiudadana.filas.push(...[arr]);
    });
  }



}
